export const drawCaptcha = (shownum, canvas) => {
  let canvaswidth = canvas.clientWidth || canvas.width
  let canvasheight = canvas.clientHeight || canvas.height
  let context = canvas.getContext('2d') // 获取到canvas画图的环境，演员表演的舞台
  canvas.width = canvaswidth
  canvas.height = canvasheight
  var sCode = 'A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0,q,w,e,r,t,y,u,i,o,p,a,s,d,f,g,h,j,k,l,z,x,c,v,b,n,m'
  var aCode = sCode.split(',')
  var aLength = aCode.length // 获取到数组的长度

  for (var i = 0; i <= 3; i++) {
    var j = Math.floor(Math.random() * aLength) // 获取到随机的索引值
    var deg = Math.random() * 30 * Math.PI / 180 // 产生0~30之间的随机弧度
    var txt = aCode[j] // 得到随机的一个内容
    shownum[i] = txt
    var x = 10 + i * 20 // 文字在canvas上的x坐标
    var y = 20 + Math.random() * 8 // 文字在canvas上的y坐标
    context.font = 'bold 23px 微软雅黑'

    context.translate(x, y)
    context.rotate(deg)

    context.fillStyle = randomColor()
    context.fillText(txt, 0, 0)

    context.rotate(-deg)
    context.translate(-x, -y)
  }
  for (var l = 0; l <= 5; l++) { // 验证码上显示线条
    context.strokeStyle = randomColor()
    context.beginPath()
    context.moveTo(Math.random() * canvaswidth, Math.random() * canvasheight)
    context.lineTo(Math.random() * canvaswidth, Math.random() * canvasheight)
    context.stroke()
  }
  for (var k = 0; k <= 30; k++) { // 验证码上显示小点
    context.strokeStyle = randomColor()
    context.beginPath()
    let x = Math.random() * canvaswidth
    let y = Math.random() * canvasheight
    context.moveTo(x, y)
    context.lineTo(x + 1, y + 1)
    context.stroke()
  }
}
export const randomColor = () => { // 得到随机的颜色值
  let r = Math.floor(Math.random() * 256)
  let g = Math.floor(Math.random() * 256)
  let b = Math.floor(Math.random() * 256)
  return 'rgb(' + r + ',' + g + ',' + b + ')'
}

/**
 * 压缩图片方法
 * base64  ----baser64文件
 * degree.quality ----压缩比例 画面质量0-9，数字越小文件越小画质越差
 * .width ----宽度
 * .height ----高度, 没有按亮度比例缩小
 * .size ----压缩后大小单位M
 * callback ---回调函数
 */
export function compressImg (base64, degree, callback) {
  // console.log(`执行缩放程序，scale=${scale}`)
  var quality = 1.0
  var size = degree.size || 5
  // 处理缩放，转换格式
  const img = new Image()
  img.src = base64
  if (base64.length < 1000 * 1000 * size) {
    callback(base64)
    return
  }
  img.onload = function () {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    let w = this.width
    let h = this.height
    let scale = w / h
    w = degree.width || w
    h = degree.height || w / scale
    canvas.setAttribute('width', w)
    canvas.setAttribute('height', h)
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
    // 转成base64 文件
    let base64 = canvas.toDataURL('image/jpeg')
    // 图像质量
    if (degree.quality && degree.quality <= 1 && degree.quality > 0) {
      quality = degree.quality
    }
    // 根据自己需求填写大小 我的目标是小于3兆
    while (base64.length > 1000 * 1000 * size) {
      quality -= 0.01
      base64 = canvas.toDataURL('image/jpeg', quality)
    }
    // // base64 TO blob
    // const arr = base64.split(',')
    // const mime = arr[0].match(/:(.*?);/)[1]
    // const bytes = atob(arr[1])
    // const bytesLength = bytes.length
    // const u8arr = new Uint8Array(bytesLength)
    // for (let i = 0; i < bytes.length; i++) {
    //   u8arr[i] = bytes.charCodeAt(i)
    // }
    // const blob = new Blob([u8arr], { type: mime })
    // // 回调函数 根据需求返回二进制数据或者base64数据，我的项目都给返回了
    // callback(blob, base64)
    // 回调函数 根据需求返回二进制数据或者base64数据，我的项目都给返回了
    callback(base64)
  }
}

// 格式化日期，如月、日、时、分、秒保证为2位数
export function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}
// 参数number为毫秒时间戳，format为需要转换成的日期格式
export function formatTime (time, format) {
  let newArr = []
  let formatArr = ['YYYY', 'MM', 'DD', 'hh', 'mm', 'ss']
  var times = new Date(time)
  newArr.push(times.getFullYear())
  newArr.push(formatNumber(times.getMonth() + 1))
  newArr.push(formatNumber(times.getDate()))

  newArr.push(formatNumber(times.getHours()))
  newArr.push(formatNumber(times.getMinutes()))
  newArr.push(formatNumber(times.getSeconds()))

  for (let i in newArr) {
    format = format.replace(formatArr[i], newArr[i])
  }
  return format
}
export function TimeStrToDate (str) {
  if (str) {
    str = str.replace('T', ' ').replaceAll('-', '/').substring(0, 19)
    return new Date(str)
  }
  return null
}
